/** Player name with optional parent/guardian name — matches players list display. */
export function formatUserWithParentDisplayName(
  name?: string | null,
  parentName?: string | null
): string {
  const playerName = String(name ?? '').trim();
  const guardianName = String(parentName ?? '').trim();

  if (playerName === '' || playerName === '-') {
    return guardianName;
  }

  return guardianName !== '' ? `${playerName}  ${guardianName}` : playerName;
}
